import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import React, { useCallback, useState } from 'react';
import { Button } from 'js/components/common/Button';
import InfoList from 'js/components/common/InfoList';
import { Toggle } from 'js/components/common/Fields/Toggle';
import { componentService } from 'js/services/component.service';
import { useCustomSelector } from 'js/store/hooks';
import { COOKIE_SETTINGS_REDUCER } from 'js/store/constants';

import * as hooks from './hooks';

import style from './CookieSettings.scss';

export const CookieSettings = () => {
    const translate = useTranslations('playtech.mobile.system.cookies.');
    const groupsData = useCustomSelector(COOKIE_SETTINGS_REDUCER, prop('groupsData'));
    const [data, setData] = useState({ ...groupsData });
    const cookiesSubmit = hooks.useSubmitCookies({ translate });

    const onToggleChange = useCallback((event) => {
        const { checked, name } = event.target;

        setData({ ...data, [name]: checked });
    }, [data, setData]);

    const onSubmit = (event) => {
        event.preventDefault();

        cookiesSubmit(data);
    };

    return (
        <form className={style.container} onSubmit={onSubmit}>
            <InfoList className={style.list}>
                <div className={style.toggleContainer}>
                    <Toggle
                        checked={true}
                        disabled="disabled"
                        className={style.toggle}
                        label={translate('name.system')}
                    />
                    <div className={style.description}>
                        {translate('description.system')}
                    </div>
                </div>
                {Object.keys(data)
                    .map((key) =>
                        <div key={key} className={style.toggleContainer}>
                            <Toggle
                                name={key}
                                checked={data[key]}
                                className={style.toggle}
                                onChange={onToggleChange}
                                label={translate(`name.${key}`)}
                            />
                            <div className={style.description}>
                                {translate(`description.${key}`)}
                            </div>
                        </div>
                    )}
            </InfoList>
            <div className={style.formActions}>
                <Button type="submit">
                    {translate('button.submit')}
                </Button>
            </div>
        </form>
    );
};

componentService.registerWebContentComponents({ CookieSettings });
